import React from "react";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";
import AppTheme, { dark_blue } from "../../utils/Theme";
import View from "../../components/ReactNative/View";
import Text from "../../components/ReactNative/Text";
import PremiumArguments from "../../components/Subscription/PremiumArguments";
import NavBarButton from "../../components/NavBar/NavBarButton";
import { IcClose } from "../../utils/Icons";
import { ScrollView } from "react-native";
import PremiumTeam from "../../components/Subscription/PremiumTeam";

interface PremiumArgumentsScreenProps {
    screenSize?: number;
    onCloseRequest: () => void;
}

const PremiumArgumentsScreen = (props: PremiumArgumentsScreenProps) => {

    const { screenSize, onCloseRequest } = props;
    const appTheme: AppTheme = new AppTheme();
    const {
        fullScreenWidth,
        fullScreenHeight,
        availableScreenSize,
        sideMenuSize
    } = useSpecificSize();

    return <View style={{ paddingStart: sideMenuSize, width: fullScreenWidth, height: fullScreenHeight, paddingTop: appTheme.topInsets + appTheme.pixelPerfect(20), alignItems: "center", justifyContent: "flex-end" }}>
        <View style={{ maxHeight: fullScreenHeight * 0.9, width: screenSize, backgroundColor: "#FFFFFF", paddingTop: appTheme.pixelPerfect(10), paddingBottom: appTheme.bottomInsets + appTheme.pixelPerfect(10), paddingHorizontal: appTheme.pixelPerfect(10), borderTopEndRadius: appTheme.pixelPerfect(14), borderTopStartRadius: appTheme.pixelPerfect(14) }}>
            <View style={{ width: screenSize, paddingHorizontal: appTheme.pixelPerfect(20), alignItems: "flex-end" }}>
                <NavBarButton icon={IcClose} color={dark_blue} action={onCloseRequest} />
            </View>
            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={{ alignItems:"center" }}>
                    <PremiumArguments />
                    <PremiumTeam screenSize={screenSize} />
                </View>
            </ScrollView>
        </View>
    </View>
}

export default PremiumArgumentsScreen;